import { Row, Col, Badge } from '@themesberg/react-bootstrap'
import React from 'react'
import {
  checkLabels,
  daysLabels,
  wageringRequirementType
} from './../components/CreateBonus/constants'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes } from '@fortawesome/pro-solid-svg-icons'
import Parser from 'html-react-parser'
import { commonDateFormat } from '../../../../utils/dateFormatter'
import { GAME_AGGREGATORS } from '../../../../constants/aggregators'
import TooltipIcon from '../../../../shared/TooltipIcon'

const GeneralDetails = ({ bonusDetail }) => {
  const isHub88 = parseInt(bonusDetail?.other?.aggregatorId) === GAME_AGGREGATORS.HUB88.ID
  const isIGD = parseInt(bonusDetail?.other?.aggregatorId) === GAME_AGGREGATORS.IGD.ID
  return (
    <>
      <Row>
        <Col sm={4}>
          <Row>
            <Col>
              <h3 className='h6 text-nowrap'>Promotion Title</h3>
            </Col>
            <Col>
              <p>{bonusDetail?.promotionTitle?.EN}</p>
            </Col>
          </Row>

          {bonusDetail?.visibleInPromotions && bonusDetail?.bonusType !== 'promotion' &&
            <Row>
              <Col>
                <h3 className='h6 text-nowrap'>Valid on Days</h3>
              </Col>
              <Col>
                {daysLabels?.map((day) => {
                  return (
                    <Col
                      key={day}
                      className='d-flex'
                      style={{
                        verticalAlign: 'middle',
                        justifyContent: 'flex-start'
                      }}
                    >
                      <p>{day}</p>
                      {bonusDetail?.validOnDays?.includes(day) && (
                        <div
                          className='rounded-circle mt-2 mx-2'
                          style={{
                            width: '10px',
                            height: '10px',
                            background: '#1aa509'
                          }}
                        />
                      )}
                    </Col>
                  )
                })}
              </Col>
            </Row>}
          <Row>
            <Col>
              <h3 className='h6 text-nowrap'>Terms and Conditions</h3>
            </Col>
            <Col>
              {bonusDetail?.termCondition?.EN && Parser(bonusDetail?.termCondition?.EN)}
            </Col>
          </Row>
        </Col>
        <Col sm={4}>
          <Row>
            <Col sm={8}>
              <h3 className='h6 text-nowrap'>Bonus Type</h3>
            </Col>
            <Col sm={4}>
              {/* <p>{bonusType.filter((type)=>)}</p> */}
              <p>{bonusDetail?.bonusType === 'freespins' ? bonusDetail?.isSticky ? 'BONUS FREESPINS' : 'CASH FREESPINS' : bonusDetail?.bonusType?.toUpperCase()}</p>
            </Col>
          </Row>
          {bonusDetail?.bonusType === 'balance' &&
            <Row>
              <Col sm={8}>
                <h3 className='h6 text-nowrap'>Applied Bonus</h3>
              </Col>
              <Col sm={4}>
                <p>{bonusDetail?.appliedBonusTitle?.EN} ({bonusDetail?.appliedBonusId})</p>
              </Col>
            </Row>}
          {bonusDetail?.bonusType === 'freespins' &&
            <Row>
              <Col sm={8}>
                <h3 className='h6 text-nowrap'>Quantity</h3>
              </Col>
              <Col sm={4}>
                {/* <p>{bonusType.filter((type)=>)}</p> */}
                <p>{bonusDetail?.quantity}</p>
              </Col>
            </Row>}
          {(bonusDetail?.bonusType === 'match' || bonusDetail?.bonusType === 'balance') &&
            <Row>
              <Col sm={8}>
                <h3 className='h6 text-nowrap'>{bonusDetail?.bonusType === 'balance' ? 'Min Balance Percentage' : 'Bonus Percentage'}</h3>
              </Col>
              <Col sm={4}>
                <p>{bonusDetail?.depositBonusPercent}%</p>
              </Col>
            </Row>}
          {!((bonusDetail?.bonusType === 'freespins' || bonusDetail?.bonusType === 'balance') && !bonusDetail?.isSticky) && !['promotion', 'winBoost'].includes(bonusDetail?.bonusType) &&
            <>
              <Row>
                <Col sm={8}>
                  <h3 className='h6 text-nowrap'>Wagering Type</h3>
                </Col>
                <Col sm={4}>
                  <p>{bonusDetail?.currency?.EUR?.minDeposit === '0' ? 'BONUS' : wageringRequirementType?.find(val => val.value === bonusDetail?.wageringRequirementType)?.label}</p>
                </Col>
              </Row>
              <Row>
                <Col sm={8}>
                  <h3 className='h6 text-nowrap'>Wagering Multiplier </h3>
                </Col>
                <Col sm={4}>
                  <p>{bonusDetail?.wageringMultiplier}</p>
                </Col>
              </Row>
              {bonusDetail?.bonusType === 'deposit' && (
                <Row>
                  <Col sm={8}>
                    <h3 className='h6 text-nowrap'>
                      Loss Threshold Percentage
                      <TooltipIcon
                        tooltipKey='lossThresholdTooltip'
                        tooltipText='This percentage determines the minimum loss threshold a player must reach before being eligible for the bonus'
                      />
                    </h3>
                  </Col>
                  <Col sm={4}>
                    <p>{bonusDetail?.other?.lossThreshold}</p>
                  </Col>
                </Row>
              )}
            </>}
          {!['promotion', 'winBoost'].includes(bonusDetail?.bonusType) &&
            <Row>
              <Col sm={8}>
                <h3 className='h6 text-nowrap'>Days To Clear</h3>
              </Col>
              <Col sm={4}>
                <p>{bonusDetail?.daysToClear}</p>
              </Col>
            </Row>}
          {/* Bet level related field */}
          {bonusDetail?.bonusType === 'freespins' && !isHub88 && !isIGD &&
            <Row>
              <Col sm={8}>
                <h3 className='h6 text-nowrap'>Bet Level</h3>
              </Col>
              <Col sm={4}>
                <p>{bonusDetail?.other?.betLevel}</p>
              </Col>
            </Row>}
          {checkLabels(bonusDetail?.bonusType).map(({ label, value }) => {
            return (
              <Row key={label}>
                <Col sm={8}>
                  <h3 className='h6 text-nowrap'>{label}</h3>
                </Col>
                <Col sm={4}>
                  <Badge
                    className='mb-3'
                    bg={bonusDetail?.[value] ? 'success' : 'dark'}
                  >
                    <FontAwesomeIcon
                      icon={bonusDetail?.[value] ? faCheck : faTimes}
                    />
                  </Badge>
                </Col>
              </Row>
            )
          })}
          {!['deposit', 'wagering'].includes(bonusDetail?.bonusType) &&
            <Row>
              <Col sm={8}>
                <h3 className='h6 text-nowrap'>Show Validity</h3>
              </Col>
              <Col sm={4}>
                <Badge
                  className='mb-3'
                  bg={bonusDetail?.other?.showBonusValidity ? 'success' : 'dark'}
                >
                  <FontAwesomeIcon
                    icon={bonusDetail?.other?.showBonusValidity ? faCheck : faTimes}
                  />
                </Badge>
              </Col>
            </Row>}
          {!['balance', 'promotion', 'freespins', 'winBoost'].includes(bonusDetail?.bonusType) &&
            <Row>
              <Col sm={8}>
                <h3 className='h6 text-nowrap'>isSticky</h3>
              </Col>
              <Col sm={4}>
                <Badge
                  className='mb-3'
                  bg={bonusDetail?.isSticky ? 'success' : 'dark'}
                >
                  <FontAwesomeIcon
                    icon={bonusDetail?.isSticky ? faCheck : faTimes}
                  />
                </Badge>
              </Col>
            </Row>}
        </Col>
        <Col sm={4}>
          {bonusDetail?.other?.ownerName && (
            <Row>
              <Col>
                <h3 className='h6 text-nowrap'>Owner Name</h3>
              </Col>
              <Col>
                <p>{bonusDetail?.other?.ownerName}</p>
              </Col>
            </Row>
          )}

          <Row>
            <Col>
              <h3 className='h6 text-nowrap'>Admin</h3>
            </Col>
            <Col>
              <p>{`${bonusDetail?.adminUser?.firstName} ${bonusDetail?.adminUser?.lastName}`}</p>
            </Col>
          </Row>
          <Row>
            <Col>
              <h3 className='h6 text-nowrap'>Tenant</h3>
            </Col>
            <Col>
              <p>{`${bonusDetail?.tenant?.name}`}</p>
            </Col>
          </Row>
          <Row>
            <Col>
              <h3 className='h6 text-nowrap'>Code</h3>
            </Col>
            <Col>
              <p>{bonusDetail?.code}</p>
            </Col>
          </Row>
          <Row>
            <Col>
              <h3 className='h6 text-nowrap'>Promotion Overview</h3>
            </Col>
            <Col>
              {bonusDetail?.promotionalOverview?.EN && Parser(bonusDetail?.promotionalOverview?.EN)}
            </Col>
          </Row>
          <Row>
            <Col>
              <h3 className='h6 text-nowrap'>Description</h3>
            </Col>
            <Col>
              {bonusDetail?.description?.EN && Parser(bonusDetail?.description?.EN)}
            </Col>
          </Row>
          {!['deposit', 'wagering', 'winBoost'].includes(bonusDetail?.bonusType) &&
            <>
              <Row>
                <Col>
                  <h3 className='h6 text-nowrap'>Valid From</h3>
                </Col>
                <Col>
                  <p>{commonDateFormat(bonusDetail?.validFrom)}</p>
                </Col>
              </Row>
              <Row>
                <Col>
                  <h3 className='h6 text-nowrap'>Valid To</h3>
                </Col>
                <Col>
                  <p>{commonDateFormat(bonusDetail?.validTo)}</p>
                </Col>
              </Row>
            </>}
          {['deposit', 'wagering', 'winBoost'].includes(bonusDetail?.bonusType) &&
            <Row>
              <Col>
                <h3 className='h6 text-nowrap'>Time Period</h3>
              </Col>
              <Col>
                <p>{parseInt(bonusDetail?.other?.timePeriod) === 1 ? 'Daily' : (parseInt(bonusDetail?.other?.timePeriod) === 7 ? 'Weekly' : 'Monthly')}</p>
              </Col>
            </Row>}
          <Row>
            <Col>
              <img src={bonusDetail?.imageUrl} height='200' width='300' alt='img' />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  )
}
export default GeneralDetails
